import {
  useEffect,
  useState,
  useRef,
  Suspense,
  useContext,
  useCallback,
  useMemo,
} from "react";
import { GetMasterTypeData } from "../../../Services/Global-Services/GlobalServices";
import { getEmployeeList } from "../EmployeeList/Service/employeeService.js";
import { MultiSelect } from "primereact/multiselect";
import { LazyImage } from "../../../Services/Decorator_Lazy_Loading/ImageVideoLazyLoding.js";
import {
  addProjectTask,
  deleteTask,
  getProjectList,
  getProjectModule,
  getProjectSegment,
  getProjectSubModule,
  getProjectTaskList,
  moveTOSprintTask,
} from "./Service/TaskService.js";
import {
  Link,
  useHistory,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min.js";
import ComponentLoader from "../../../Shared/Sidebar/ComponentLoader.jsx";
import { Paginator } from "primereact/paginator";
import { TostMsg } from "../../../App.js";
import { useLocation } from "react-router-dom";
import { Dropdown } from "primereact/dropdown";
import AddTask from "./Add-Task.jsx";
import { getRawPermissionsArray } from "../../../Routes/AuthGard/usePermissions.js";
import { ProjectModalContext } from "./Service/ProjectModalContext.jsx";

const BackLockSprints = () => {
  const { selectedProject: contextProject, updateSelectedProject, refreshSelectedProject } = useContext(ProjectModalContext);
  const COLUMNS = ["Open", "In Progress", "Review", "Done", "Closed"];
  const COLUMN_COLORS = {
    Open: "var(--s-open)",
    "In Progress": "var(--s-inprog)",
    Review: "var(--s-review)",
    Resolved: "var(--s-resolved)",
    Done: "var(--s-resolved)",
    Closed: "var(--s-closed)",
  };
  const STATUS_UI = [
    { key: "Open", className: "sc-open", icon: "fa-folder-open" },
    { key: "In Progress", className: "sc-inprog", icon: "fa-spinner" },
    { key: "Review", className: "sc-review", icon: "fa-eye" },
    { key: "Resolved", className: "sc-done", icon: "fa-check-circle" },
    { key: "Closed", className: "sc-closed", icon: "fa-lock" },
  ];

  const SORT_OPTIONS = [
    { label: "Modified On(Default)", value: "" },
    { label: "Assigned To", value: "AssignedToName" },
    { label: "Priority", value: "PriorityId" },
    { label: "Severity", value: "SeverityId" },
    { label: "Type", value: "TaskTypeId" },
    { label: "Module", value: "ModuleName" },
    { label: "Sub Module", value: "SubModuleName" },
    { label: "Status", value: "StatusId" },
    { label: "Created On", value: "CreatedOn" },
    { label: "Reporter", value: "ReporterFullName" },
  ];

  const [view, setView] = useState("list");
  const [selectedTasks, setSelectedTasks] = useState([]);
  const [showBulkBar, setShowBulkBar] = useState(false);
  const [selectedAssingToName, setSelectedAssingToName] = useState([]);
  const [taskList, setTaskList] = useState([]);
  const [filteredTasks, setFilteredTasks] = useState([]);
  const [inputText, setInputText] = useState("");
  const [searchText, setSearchText] = useState("");
  const [startDate, setStartDate] = useState("2020-01-01");
  const [endDate, setEndDate] = useState("2029-12-31");
  const getValue = (val) => (val ? val : "N/A");
  const [taskSegmentType, setTaskSegmentType] = useState([]);
  const [taskModuleType, setTaskModuleType] = useState([]);
  const [taskSeverityType, setTaskSeverityType] = useState([]);
  const [taskPriorityType, setTaskPriorityType] = useState([]);
  const [taskSubModuleType, setTaskSubModuleType] = useState([]);
  const [taskStatusType, setTaskStatusType] = useState([]);
  const [selectedProject, setSelectedProject] = useState(null);
  const [employeDetails, setEmployeDetails] = useState([]);
  const [Isloading, setIsloading] = useState(false);
  const [IsApiloading, setApiloading] = useState(false);
  const [selectedTask, setSelectedTask] = useState(null);
  const [taskCount, setTaskCount] = useState([]);
  const toster = useContext(TostMsg);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(50);
  const [totalRecords, setTotalRecords] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [subTaskProjectId, setProjectId] = useState(0);
  const [filterOpen, setFilterOpen] = useState(false);
  const [summaryOpen, setSummaryOpen] = useState(false);
  const [guidApplied, setGuidApplied] = useState(false);
  const [sortBy, setSortBy] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const debounceTimerRef = useRef(null);
  const [copiedId, setCopiedId] = useState(null);
  let userPermissions = getRawPermissionsArray();
  const statusMap = taskCount.reduce((acc, item) => {
    acc[item.Status] = item.TaskCount;
    return acc;
  }, {});
  const userDetails = useMemo(() => {
    return JSON.parse(localStorage.getItem("User") || "{}");
  }, []);
  const history = useHistory();
  const [selectedraisedBy, setSelectedraisedBy] = useState([]);
  const location = useLocation();
  const [header, setHeader] = useState("");
  const [allProject, setAllProject] = useState([]);
  const [taskType, setTaskType] = useState([]);
  const [deletedTaskId, setDeletedTaskId] = useState(0);
  const [isDeletedModal, setDeleteModal] = useState(false);
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  const { ProjectGUID } = useParams();
  const normalizedProjectGUID = ProjectGUID?.toString().toLowerCase();
  const [selectedPriority, setSelectedPriority] = useState([]);
  const [selectedSeverity, setSelectedSeverity] = useState([]);
  // const [selectedStatus, setSelectedStatus] = useState();
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [selectedSegment, setSelectedSegment] = useState([]);
  const [selectedSubModule, setSelectedSubModule] = useState([]);
  const [selectedModule, setSelectedModule] = useState([]);
  const [selectedType, setSelectedType] = useState([]);
  const [isModalOpen, setAddModalOpen] = useState(false);
  const [editTaskDetails, setEditTaskDetails] = useState({});
  const [parentId, setParentId] = useState(0);
  const [taskCopy, setTaskCopy] = useState(false);
  const [selectedTaskDrag, setSelectedTaskDrag] = useState([]);
  const { registerProjectSaveCallback } = useContext(ProjectModalContext);
  const [panelEmployees, setPanelEmployees] = useState([]);
  const [localSelectedStatus, setLocalSelectedStatus] = useState();
  const isInitializedRef = useRef(false);
  const selectedProjectRef = useRef(selectedProject);
  const selectedStatusRef = useRef([]);
  const rowsRef = useRef(rows);
  const [isSprintModal, setIsSprintModal] = useState(false);
  const [moveSprint, setMoveSprint] = useState(null);
  const [sprintDropdownTaskId, setSprintDropdownTaskId] = useState(null);
  const [selectedProjectData, setSelectedProjectData] = useState(null);
  const [projectNameValue, setProjectName] = useState()
  const backlogTasks = filteredTasks.filter(t => t.SprintId === 0);

  const [createProject, setCreateProject] = useState(false);


  const permissionList = () => {
    if (userPermissions) {
      userPermissions?.map((UserPermission) => {
        if (UserPermission?.PermissionName === "Project.Create") setCreateProject(true);
      });
    }
  };

  const toggleAllSel = (e) => {
    if (e.target.checked) {
      setSelectedTasks(backlogTasks.map((t) => t.Id));
      setShowBulkBar(true);
    } else {
      setSelectedTasks([]);
      setShowBulkBar(false);
    }
  };


  useEffect(() => {
    const statuses = userDetails?.OrgTaskStatus;
    if (statuses?.length) {
      const filteredIds = statuses
        .filter((item) => item.CategoryId === 1 && item.Code !== "104")
        .map((item) => item.Id);

      // selectedStatus set karo taaki getProjectTask API mein StatusId filter lage
      selectedStatusRef.current = filteredIds;
      setSelectedStatus(filteredIds);
      setLocalSelectedStatus(filteredIds); // agar localSelectedStatus kahi aur use ho raha ho
    }
    return () => {
      if (debounceTimerRef.current) clearTimeout(debounceTimerRef.current);
    };
    permissionList();
  }, []);

  useEffect(() => {
    selectedProjectRef.current = selectedProject;
  }, [selectedProject]);

  useEffect(() => {
    rowsRef.current = rows;
  }, [rows]);
  useEffect(() => {
    if (selectedProject && allProject?.length > 0) {
      const projectData = allProject.find(p => p.Id === selectedProject);
      setProjectName(projectData)
    }

  }, [selectedProject, allProject]);

  useEffect(() => {
    const handleOutsideClick = () => setSprintDropdownTaskId(null);
    if (sprintDropdownTaskId !== null) {
      document.addEventListener("click", handleOutsideClick);
    }
    return () => document.removeEventListener("click", handleOutsideClick);
  }, [sprintDropdownTaskId]);



  const hasActiveFilters =
    searchText ||
    selectedStatus?.length > 0 ||
    selectedPriority?.length > 0 ||
    selectedSeverity?.length > 0 ||
    selectedModule?.length > 0 ||
    selectedSubModule?.length > 0 ||
    selectedSegment?.length > 0 ||
    selectedProject !== null ||
    selectedAssingToName?.length > 0 ||
    selectedraisedBy?.length > 0 ||
    selectedType?.length > 0 ||
    startDate ||
    endDate ||
    sortBy;

  const toggleSortOrder = () =>
    setSortOrder((prev) => (prev === "ASC" ? "DESC" : "ASC"));

  useEffect(() => {
    registerProjectSaveCallback(() =>
      getProjectTask(1, rowsRef.current, selectedProjectRef.current)
    );
  }, [registerProjectSaveCallback]);

  // ─── FIX: Init effect - sirf location/ProjectGUID change par chale ──────────
  useEffect(() => {
    isInitializedRef.current = false; // route change par reset

    const init = async () => {
      if (location.pathname === "/Project/Task/List") {
        setHeader("My Tasks");
      } else {
        setHeader("Backlog");
      }

      // Static data aur employees parallel mein load karo
      const [projects] = await Promise.all([
        allProjects(),
        fetchEmployeeIdData(),
        getMasterTaskSeverityCategory(),
        getMasterTaskPriorityCategory(),
        getMasterTaskStatusCategory(),
        getMasterTaskTypeCategory(),
        GetMasterSystemAlertList(),
      ]);

      if (ProjectGUID && projects.length > 0) {
        const normalizedGUID = ProjectGUID.toString().toLowerCase();
        const matchedProject = projects.find(
          (p) => (p?.GUID || "").toString().toLowerCase() === normalizedGUID
        );

        if (matchedProject) {
          const projectId =
            matchedProject?.Id || matchedProject?.ProjectId || 0;
          setSelectedProject(projectId);
          selectedProjectRef.current = projectId;
          setGuidApplied(true);
          getMasterTaskModulesCategory(projectId);
          getMasterTaskSegementCategory(projectId);
          await fetchEmployeeIdData(projectId);
          isInitializedRef.current = true;
          await getProjectTask(1, rowsRef.current, projectId);
          return;
        }
      }

      isInitializedRef.current = true;
      await getProjectTask(1, rowsRef.current, null, selectedStatusRef.current);
    };

    init();
  }, [location.pathname, ProjectGUID]);

  // ─── FIX: Filter effect - init ke baad hi chale, aur selectedProject stable ho
  useEffect(() => {
    if (!isInitializedRef.current) return; // init complete hone se pehle mat chalo
    getProjectTask(1, rowsRef.current);
    setFirst(0);
    setPageNumber(1);
  }, [
    searchText,
    selectedStatus,
    selectedPriority,
    selectedSeverity,
    selectedModule,
    selectedSubModule,
    selectedSegment,
    selectedProject,
    selectedAssingToName,
    startDate,
    endDate,
    selectedType,
    sortBy,
    sortOrder,
  ]);

  // ─── GUID match after allProject loads ─────────────────────────────────────
  useEffect(() => {
    if (
      ProjectGUID &&
      allProject?.length > 0 &&
      selectedProject === null &&
      !guidApplied
    ) {
      const matchedProject = allProject.find(
        (project) =>
          (project?.GUID || "").toString().toLowerCase() ===
          normalizedProjectGUID
      );

      if (matchedProject) {
        const projectId =
          matchedProject?.Id || matchedProject?.ProjectId || 0;
        setSelectedProject(projectId);
        selectedProjectRef.current = projectId;
        setGuidApplied(true);
        getMasterTaskModulesCategory(projectId);
        getMasterTaskSegementCategory(projectId);
        getProjectTask(1, rowsRef.current, projectId);
      }
    }
  }, [allProject]);

  // ─── HELPERS ─────────────────────────────────────────────────────────────────
  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      }
    });
  }, []);

  async function allProjects() {
    let body = {
      Id: 0,
      StartDate: "",
      EndDate: "",
      ProjectStatusId: "",
      PageNumber: 1,
      PageSize: 1000,
      Search: "",
      ProjectTypeId: "",
      ClientId: "",
      SortBy: "",
      SortOrder: "",
    };

    try {
      let res = await getProjectList(body);
      const projectList = res?.Data?.ProjectList || [];
      const normalizedProjects = projectList.map((project) => ({
        ...project,
        Id: project?.Id ?? project?.ProjectId ?? 0,
        ProjectId: project?.ProjectId ?? project?.Id ?? 0,
        GUID: (
          project?.GUID ??
          project?.Guid ??
          project?.ProjectGUID ??
          project?.ProjectGuid ??
          ""
        )
          .toString()
          .toLowerCase(),
      }));
      setAllProject(normalizedProjects);
      return normalizedProjects;
    } catch (error) {
      toster.current.error(error.res.Data?.Message || "somthing went wrong"); return [];
    }
  }

  const sBadge = (status) => {
    const map = {
      Active: "bg-active",
      Archived: "bg-archived",
      Open: "bg-open",
      "In Progress": "bg-inprog",
      Review: "bg-review",
      Done: "bg-success",
      Closed: "bg-success",
    };
    return map[status] || "bg-medium";
  };

  async function getProjectTask(
    page = 1,
    pageSize = 10,
    projectId = undefined,
    statusIds = undefined
  ) {
    const assignedId =
      location.pathname === "/Project/Task/List"
        ? userDetails?.EmpId?.toString()
        : "";

    setApiloading(true);
    setTotalRecords(0);
    const resolvedProjectId =
      projectId !== undefined ? projectId : selectedProjectRef.current;

    const statusIdValue = typeof statusIds === "string"
      ? statusIds
      : Array.isArray(statusIds)
        ? statusIds.join(",")
        : selectedStatus?.join(",") || selectedStatusRef.current?.join(",") || "";

    const params = {
      RaisedByEmpId: selectedraisedBy?.join(",") || "",
      AssignedToId:
        selectedAssingToName?.length > 0
          ? selectedAssingToName.join(",")
          : assignedId || "",
      TaskId: 0,
      StatusId: statusIdValue,
      ModuleId: selectedModule?.join(",") || "",
      SubModuleId: selectedSubModule?.join(",") || "",
      PriorityId: selectedPriority?.join(",") || "",
      SeverityId: selectedSeverity?.join(",") || "",
      Search: searchText || "",
      FilterStartDate: startDate || "",
      FilterEndDate: endDate || "",
      PageNumber: page,
      PageSize: pageSize,
      IsDeleted: 0,
      SprintId: 0,
      TaskNumber: "",
      TaskGUID: "",
      ProjectId: resolvedProjectId ? resolvedProjectId.toString() : "",
      ParentTaskId: 0,
      TaskTypeId: selectedType?.join(",") || "",
      SegmentId: selectedSegment?.join(",") || "",
      SortBy: sortBy || "",
      SortOrder: sortOrder || "",
    };

    try {
      const data = await getProjectTaskList(params);
      const list = data?.Data?.OrgEmpTasks || [];
      const count = data?.Data?.TaskStatusCounts || [];
      // const total = list?.[0]?.TotalCount || 0;
      // setTotalRecords(total);
      const backlogList = list.filter(t => t.SprintId === 0);
      const total = backlogList?.[0]?.TotalCount || 0;
      setTotalRecords(total);
      setTaskCount(count);
      // setTaskList(list.map((el) => ({ ...el, isDraggingDropping: false })));
      setFilteredTasks(
        list.map((el) => ({ ...el, isDraggingDropping: false }))
      );
    } catch (error) {
      toster.current.error(error.data.Data?.Message || "somthing went wrong");
    } finally {
      setApiloading(false);
    }
  }

  async function taskDelete() {
    let body = { Id: deletedTaskId };
    setIsloading(true);
    try {
      if (deletedTaskId) {
        let response = await deleteTask(body);
        if (response?.StatusCode === 2000) {
          GetMasterSystemAlertList("Task_Delete", 0);
          await getProjectTask(1, rowsRef.current);
          setDeleteModal(false);
          setDeletedTaskId(0);
        }
      }
    } catch (error) {
      toster.current.error(error.response.Data?.Message || "somthing went wrong");
    } finally {
      setIsloading(false);
    }
  }

  const onPageChange = (e) => {
    setFirst(e.first);
    setRows(e.rows);
    rowsRef.current = e.rows;
    const newPage = Math.floor(e.first / e.rows) + 1;
    setPageNumber(newPage);
    getProjectTask(newPage, e.rows);
  };

  const employeeOptionTemplate = (option) => {
    if (!option) return null;
    return (
      <div className="flex align-items-center gap-2 ticket-file-attach__items_detail">
        <LazyImage
          alt={option?.FullName || "User"}
          src={option?.ProfileImage || "/images/placeholder_profile.png"}
          width="32"
        />
        <span>{option?.FullName || "Unknown"}</span>
      </div>
    );
  };

  const applyFilters = () => {
    let data = [...taskList];
    const search = searchText.toLowerCase();

    if (search) {
      data = data.filter(
        (t) =>
          (t.TaskTitle || "").toLowerCase().includes(search) ||
          String(t.TaskNumber || "").toLowerCase().includes(search)
      );
    }
    if (selectedStatus?.length) {
      data = data.filter((t) =>
        selectedStatus.map(String).includes(String(t.StatusId))
      );
    }
    if (selectedPriority?.length) {
      data = data.filter((t) =>
        selectedPriority.map(String).includes(String(t.PriorityId))
      );
    }
    if (selectedSeverity?.length) {
      data = data.filter((t) =>
        selectedSeverity.map(String).includes(String(t.SeverityId))
      );
    }
    if (selectedProject) {
      data = data.filter(
        (t) => String(t.ProjectId) === String(selectedProject)
      );
    }
    if (selectedType?.length) {
      data = data.filter((t) =>
        selectedType.map(String).includes(String(t.TaskTypeId))
      );
    }
    if (selectedModule?.length) {
      data = data.filter((t) =>
        selectedModule.map(String).includes(String(t.ModuleId))
      );
    }
    if (selectedSubModule?.length) {
      data = data.filter((t) =>
        selectedSubModule.map(String).includes(String(t.SubModuleId))
      );
    }
    if (selectedSegment?.length) {
      data = data.filter((t) =>
        selectedSegment.map(String).includes(String(t.SegmentId))
      );
    }
    if (selectedAssingToName?.length) {
      data = data.filter((t) =>
        selectedAssingToName.includes(t.AssignedToId)
      );
    }
    setFilteredTasks(data);
  };

  const clearFilters = () => {
    setInputText("");
    setSearchText("");
    setSelectedStatus([]);
    setSelectedPriority([]);
    setSelectedSeverity([]);
    setSelectedModule([]);
    setSelectedSubModule([]);
    setSelectedSegment([]);
    setSelectedProject(null);
    selectedProjectRef.current = null;
    setSelectedAssingToName([]);
    setSelectedraisedBy([]);
    setTaskModuleType([]);
    setTaskSubModuleType([]);
    setTaskSegmentType([]);
    setSelectedType([]);
    setStartDate("");
    setEndDate("");
    setSortBy("");
    setSortOrder("ASC");
  };

  ;

  const closePanel = () => setSelectedTask(null);

  async function getMasterTaskSegementCategory(projectId = 0) {
    try {
      const data = await getProjectSegment({ ProjectId: Number(projectId) });
      setTaskSegmentType(data?.Data);
    } catch (error) {
      toster.current.error(error.data.Data?.Message || "somthing went wrong");
    }
  }

  async function fetchPanelEmployees(projectId = 0) {
    const params = {
      OrganisationId: userDetails?.OrgId,
      LoggedInEmployeeId: userDetails?.EmpId,
      IsDirectReportOrHierarchy: 0,
      SearchText: "",
      FollowersOnly: 0,
      FollowingsOnly: 0,
      IsExEmployeesAlso: 0,
      pageNumber: 1,
      pageSize: 10000,
      EmployeeId: 0,
      IsSuggestedOnly: 0,
      ZoneId: 0,
      RegionId: 0,
      ProjectId: Number(projectId) || 0,
    };
    try {
      let res = await getEmployeeList(params);
      setPanelEmployees(res.Data || []);
    } catch (error) {
      toster.current.error(error.res.Data?.Message || "somthing went wrong");
    }
  }

  async function fetchEmployeeIdData(projectId = 0) {
    const params = {
      OrganisationId: userDetails?.OrgId,
      LoggedInEmployeeId: userDetails?.EmpId,
      IsDirectReportOrHierarchy: 0,
      SearchText: "",
      FollowersOnly: 0,
      FollowingsOnly: 0,
      IsExEmployeesAlso: 0,
      pageNumber: 1,
      pageSize: 10000,
      EmployeeId: 0,
      IsSuggestedOnly: 0,
      ZoneId: 0,
      RegionId: 0,
      ProjectId: Number(projectId) || 0,
    };

    try {
      let employeesList = await getEmployeeList(params);
      setEmployeDetails(employeesList.Data || []);
    } catch (error) {
      toster.current.error(error.employeesList.Data?.Message || "somthing went wrong");
    } finally {
      setIsloading(false);
    }
  }

  async function getMasterTaskModulesCategory(projectId = 0) {
    try {
      const data = await getProjectModule({ ProjectId: Number(projectId) });
      setTaskModuleType(data?.Data || []);
    } catch (error) {
      toster.current.error(error.data.Data?.Message || "somthing went wrong");
    }
  }

  const toggleSection = (key) => {
    if (key === "filter") {
      setFilterOpen(!filterOpen);
    } else if (key === "summary") {
      setSummaryOpen(!summaryOpen);
    }
  };

  const renderToggleArrow = (isOpen, color = "currentColor") => (
    <svg
      viewBox="0 0 20 20"
      width="18"
      height="18"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      style={{ display: "block" }}
    >
      <path
        d={isOpen ? "M5 12l5-5 5 5" : "M5 7l5 5 5-5"}
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  async function getMasterTaskSeverityCategory() {
    try {
      const data = await GetMasterTypeData({
        organisationId: userDetails?.OrgId,
        masterType: "TaskSeverity",
      });
      setTaskSeverityType(data?.Data);
    } catch (error) {
      toster.current.error(error.data.Data?.Message || "somthing went wrong");
    }
  }

  async function getMasterTaskPriorityCategory() {
    try {
      const data = await GetMasterTypeData({
        organisationId: userDetails?.OrgId,
        masterType: "TaskPriority",
      });
      setTaskPriorityType(data?.Data);
    } catch (error) {
      toster.current.error(error.data.Data?.Message || "somthing went wrong");
    }
  }

  async function getMasterTaskSubModuleCategory(projectId = 0, moduleId = 0) {
    try {
      const data = await getProjectSubModule({
        ProjectId: Number(projectId),
        ModuleId: Number(moduleId),
      });
      setTaskSubModuleType(data?.Data || []);
    } catch (error) {
      toster.current.error(error.data.Data?.Message || "somthing went wrong");
    }
  }

  async function getMasterTaskStatusCategory() {
    try {
      const data = await GetMasterTypeData({
        organisationId: userDetails?.OrgId,
        masterType: "TaskStatus",
      });
      setTaskStatusType(data?.Data);
    } catch (error) {
      toster.current.error(error.data.Data?.Message || "somthing went wrong");
    }
  }

  async function getMasterTaskTypeCategory() {
    try {
      const data = await GetMasterTypeData({
        organisationId: userDetails?.OrgId,
        masterType: "TaskType",
      });
      setTaskType(data?.Data);
    } catch (error) {
      toster.current.error(error.data.Data?.Message || "somthing went wrong");
    }
  }

  const openPanel = (id) => {
    const task = filteredTasks.find((t) => t.Id === id);
    setSelectedTask(task);
  };

  const taskDetail = (id) => {
    window.open(`/Project/Task/Detail/${id}`, "_blank");
  };

  const STATUS_DISPLAY_TO_API = {
    Open: "Open",
    "In Progress": "In Progress",
    Review: "Review",
    Resolved: "Done",
    Closed: "Closed",
  };

  const handleStatusChange = async (taskId, statusName) => {

    setIsloading(true);
    const apiStatusName = STATUS_DISPLAY_TO_API[statusName] || statusName;
    const statusObj = taskStatusType.find((s) => s.Name === apiStatusName);
    if (!statusObj) {
      setIsloading(false);
      return;
    }
    const task = filteredTasks.find((t) => t.Id === taskId);
    if (!task) {
      setIsloading(false);
      return;
    }
    const body = {
      Id: taskId,
      ProjectId: Number(task.ProjectId),
      TaskTitle: task.TaskTitle,
      TaskDescription: task.TaskDescription || "",
      AssignedToId: Number(task.AssignedToId),
      ReporterId: Number(task.ReporterId),
      TaskTypeId: Number(task.TaskTypeId),
      PriorityId: Number(task.PriorityId),
      SeverityId: Number(task.SeverityId),
      StatusId: Number(statusObj.Id),
      ModuleId: Number(task.ModuleId),
      SubModuleId: Number(task.SubModuleId),
      SegmentId: Number(task.SegmentId),
      DueDate: task.DueDate?.split(" ")[0] || "",
      EstimatedHours: Number(task.EstimatedHours || 0),
      Comment: "",
      SprintId: Number(task?.SprintId),
      ActualHours: Number(task?.ActualHours || 0),
      ParentTaskId: Number(task?.ParentTaskId || 0),
    };

    try {
      await addProjectTask(body);
      await getProjectTask(1, rowsRef.current);
      GetMasterSystemAlertList("Status_Update", 0);
      setSelectedTask((prev) => ({
        ...prev,
        StatusName: statusName,
        StatusId: statusObj.Id,
      }));
    } catch (err) {
      toster.current.error(err.data.Data?.Message || "somthing went wrong");
    } finally {
      setIsloading(false);
    }
  };

  const onClosePopup = (e) => {
    setAddModalOpen(false);
    setEditTaskDetails({});
    setProjectId(0);
    if (e === "success") {
      getProjectTask(1, rowsRef.current);
    }
    setParentId(0);
    setTaskCopy(false);
    setFirst(0);
  };

  const handleDrop = async (event, task) => {
    event.preventDefault();
    const statusObj = taskStatusType.find((s) => s.Name === task);
    if (!statusObj) return;

    setFilteredTasks((prev) =>
      prev.map((f) =>
        f.Id === selectedTaskDrag.Id
          ? { ...f, StatusName: task, StatusId: statusObj.Id }
          : f
      )
    );

    setIsloading(true);
    const body = {
      Id: selectedTaskDrag.Id,
      ProjectId: Number(selectedTaskDrag.ProjectId),
      TaskTitle: selectedTaskDrag.TaskTitle,
      TaskDescription: selectedTaskDrag.TaskDescription || "",
      AssignedToId: Number(selectedTaskDrag.AssignedToId),
      ReporterId: Number(selectedTaskDrag.ReporterId),
      TaskTypeId: Number(selectedTaskDrag.TaskTypeId),
      PriorityId: Number(selectedTaskDrag.PriorityId),
      SeverityId: Number(selectedTaskDrag.SeverityId),
      StatusId: Number(statusObj?.Id),
      ModuleId: Number(selectedTaskDrag.ModuleId),
      SubModuleId: Number(selectedTaskDrag.SubModuleId),
      SegmentId: Number(selectedTaskDrag.SegmentId),
      DueDate: selectedTaskDrag.DueDate?.split(" ")[0] || "",
      EstimatedHours: Number(selectedTaskDrag.EstimatedHours || 0),
      Comment: "",
      SprintId: 0,
      ActualHours: 0,
      ParentTaskId: selectedTaskDrag?.ParentTaskId || 0,
    };
    try {
      const response = await addProjectTask(body);
      if (response?.StatusCode === 2000) {
        toster.current.success("Task status updated successfully");
        await getProjectTask(1, rowsRef.current);
      } else {
        toster.current.error("Something went wrong. Please try again.");
      }
    } catch (err) {
      toster.current.error("Something went wrong. Please try again.");
    } finally {
      setIsloading(false);
    }
  };

  const handleAssigneeChange = async (newEmpId) => {
    const emp = employeDetails.find((em) => em.Id === newEmpId);
    setIsloading(true);
    const body = {
      Id: selectedTask.Id,
      ProjectId: Number(selectedTask.ProjectId),
      TaskTitle: selectedTask.TaskTitle,
      TaskDescription: selectedTask.TaskDescription || "",
      AssignedToId: newEmpId,
      ReporterId: Number(selectedTask.ReporterId),
      TaskTypeId: Number(selectedTask.TaskTypeId),
      PriorityId: Number(selectedTask.PriorityId),
      SeverityId: Number(selectedTask.SeverityId),
      StatusId: Number(selectedTask.StatusId),
      ModuleId: Number(selectedTask.ModuleId),
      SubModuleId: Number(selectedTask.SubModuleId),
      SegmentId: Number(selectedTask.SegmentId),
      DueDate: selectedTask.DueDate?.split(" ")[0] || "",
      EstimatedHours: Number(selectedTask.EstimatedHours || 0),
      Comment: "",
      SprintId: Number(selectedTask?.SprintId || 0),
      ActualHours: Number(selectedTask?.ActualHours || 0),
      ParentTaskId: Number(selectedTask?.ParentTaskId || 0),
    };
    try {
      await addProjectTask(body);
      await getProjectTask(1, rowsRef.current);
      setSelectedTask((prev) => ({
        ...prev,
        AssignedToId: newEmpId,
        AssignToName: emp?.FullName || prev.AssignToName,
      }));
    } catch (err) {
      console.log(err);
    } finally {
      setIsloading(false);
    }
  };


  async function sendMoveSprint() {
    const params = {
      ProjectId: Number(moveSprint?.ProjectId || 0),
      TaskId: Number(moveSprint?.Id || 0),
      SourceSprintId: Number(moveSprint?.SprintId || 0),
      TargetSprintId: Number(moveSprint?.targetSprint?.Id || 0),
    };
    setIsloading(true);
    try {
      const response = await moveTOSprintTask(params);
      setIsSprintModal(false);
      getProjectTask(1, rowsRef.current, moveSprint?.ProjectId);
      toster.current.success(
        response?.Message
      );
    } catch (error) {
      toster.current.error(
        error?.response?.Message || "Something went wrong"
      );
    } finally {
      setIsloading(false);
    }
  }


  async function sendBulkMoveSprint(targetSprint) {
    setIsloading(true);
    const backlogTasks = filteredTasks.filter(
      t => selectedTasks.includes(t.Id) && t.SprintId === 0
    );

    try {
      await Promise.all(
        backlogTasks.map(task =>
          moveTOSprintTask({
            ProjectId: Number(task.ProjectId),
            TaskId: Number(task.Id),
            SourceSprintId: Number(task.SprintId || 0),
            TargetSprintId: Number(targetSprint.Id),
          })
        )
      );
      toster.current.success(`${backlogTasks.length} task(s) moved to sprint`);
      setSelectedTasks([]);
      setShowBulkBar(false);
      getProjectTask(1, rowsRef.current);
    } catch (err) {
      toster.current.error(err?.response?.Message || "Something went wrong");
    } finally {
      setIsloading(false);
    }
  }

  // ─── RENDER ──────────────────────────────────────────────────────────────────
  return (
    <div className="">
      <div className="task-top-pane">
        <i className="fa fa-thumb-tack i-ico" aria-hidden="true"></i>
        <div className="task-top-pane-title">
          <h4>Welcome to OrgGenie</h4>
          <p>Manage your tasks, projects, and workspaces in one place.</p>
        </div>
      </div>
      <div className="tm-main-area">
        <div className="page-head">
          <div>
            <h2>{header} {projectNameValue?.Name && `(${projectNameValue.Name})`}</h2>
          </div>
          <div className="head-actions">
            <div className="flex ic gap8">
              <button
                className="btn btn-brand btn-sm"
                onClick={() => setAddModalOpen(true)}
              >
                <i className="fa-solid fa-plus"></i> New Task
              </button>
              <Link
                to="/Project/Dashboard"
                className="btn-og btn-og-secondary btn-og-sm"
                style={{ display: "flex", justifyContent: "flex-start" }}
                title="Back"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-arrow-left"
                  viewBox="0 0 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"
                  />
                </svg>
              </Link>


            </div>
          </div>
        </div>

        <div className="page">
          {/* SUMMARY COLLAPSIBLE SECTION */}
          {/* <div className="collapsible-section" id="summarySection">
            <div
              className="section-toggle summery-box-label"
              onClick={() => toggleSection("summary")}
            >
              <div className="section-toggle-icon icon-summary">
                <svg
                  viewBox="0 0 28 28"
                  width="16"
                  height="16"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                >
                  <rect width="28" height="28" rx="8" fill="none" />
                  <rect x="7" y="15" width="4" height="7" rx="1" fill="#1a56db" />
                  <rect x="12" y="11" width="4" height="11" rx="1" fill="#1a56db" />
                  <rect x="17" y="7" width="4" height="15" rx="1" fill="#1a56db" />
                </svg>
              </div>
              <span className="section-label">Summary</span>
              {!summaryOpen &&
                STATUS_UI.map((item) => (
                  <div key={item.key} className={`stat-card ${item.className}`}>
                    <div className="sc-label ">{item.key}</div>
                    <div className="sc-value">{statusMap[item.key] || 0}</div>
                    <i className={`fa ${item.icon} sc-icon`}></i>
                  </div>
                ))}
              <span className="section-hint" id="summaryHint">
                Task Overview
              </span>
              <div
                className={`section-toggle-arrow ${summaryOpen ? "open" : ""}`}
                id="summaryChevron"
                style={{ color: "#1a56db" }}
              >
                {renderToggleArrow(summaryOpen, "#1a56db")}
              </div>
            </div>

            <div
              className={`section-body ${summaryOpen ? "open" : ""}`}
              id="summaryBody"
            >
              <div
                className="section-body-inner"
                onClick={(e) => e.stopPropagation()}
              >
                <div id="sumStrip">
                  <div
                    className="stat-grid mb-0"
                    style={{ gridTemplateColumns: "repeat(5,1fr)" }}
                  >
                    {STATUS_UI.map((item) => (
                      <div
                        key={item.key}
                        className={`stat-card ${item.className}`}
                      >
                        <div className="sc-label">{item.key}</div>
                        <div className="sc-value">
                          {statusMap[item.key] || 0}
                        </div>
                        <i className={`fa ${item.icon} sc-icon`}></i>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div> */}

          {/* FILTER COLLAPSIBLE SECTION */}
          <div
            className="collapsible-section"
            id="filterSection"
            onClick={() => toggleSection("filter")}
          >
            <div className="section-toggle">
              <div
                className="section-toggle-icon icon-filter"
                onClick={() => toggleSection("filter")}
              >
                <svg
                  viewBox="0 0 28 28"
                  width="28"
                  height="28"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                >
                  <rect width="28" height="28" rx="8" fill="#f0fdf4" />
                  <path
                    d="M7 9.5h14M9.5 14h9M12 18.5h4"
                    stroke="#15803d"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                  />
                </svg>
              </div>
              <span
                className="section-label"
                onClick={() => toggleSection("filter")}
              >
                Filters
              </span>

              <div
                className="sort-bydiv"
                onClick={(e) => e.stopPropagation()}
              >
                <label
                  style={{
                    fontSize: "11px",
                    color: "var(--muted)",
                    whiteSpace: "nowrap",
                    marginBottom: "0",
                  }}
                >
                  Sort By:
                </label>
                <select
                  className="fs"
                  style={{ width: "auto" }}
                  value={sortBy}
                  onChange={(e) => {
                    setSortBy(e.target.value);
                    setSortOrder("ASC");
                  }}
                >
                  {SORT_OPTIONS.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                      {opt.label}
                    </option>
                  ))}
                </select>

                <button
                  type="button"
                  className="btn btn-ghost btn-icon btn-sm"
                  title={
                    sortOrder === "ASC"
                      ? "Ascending — click for Descending"
                      : "Descending — click for Ascending"
                  }
                  onClick={toggleSortOrder}
                  disabled={!sortBy}
                  style={{
                    opacity: sortBy ? 1 : 0.35,
                    cursor: sortBy ? "pointer" : "not-allowed",
                    fontSize: "13px",
                    width: "30px",
                    height: "30px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    border: "1px solid var(--border)",
                    borderRadius: "var(--radius)",
                    background: sortBy ? "var(--card)" : "transparent",
                    transition: "all 0.15s",
                  }}
                >
                  {sortOrder === "ASC" ? (
                    <i className="fa-solid fa-arrow-up-a-z"></i>
                  ) : (
                    <i className="fa-solid fa-arrow-down-z-a"></i>
                  )}
                </button>
              </div>
            </div>

            <div
              className={`section-body ${filterOpen ? "open" : ""}`}
              id="filterBody"
            >
              <div
                className="section-body-inner"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="toolbar my-toolbar">
                  <div className="toolbar-sepdiv">
                    <div
                      className="sw"
                      style={{ flex: "2 1 220px", minWidth: 180 }}
                    >
                      <i className="fa-solid fa-magnifying-glass"></i>
                      <input
                        className="si"
                        placeholder="Search tasks, ID…"
                        value={inputText}
                        onChange={(e) => {
                          const value = e.target.value;
                          setInputText(value);
                          if (debounceTimerRef.current)
                            clearTimeout(debounceTimerRef.current);
                          debounceTimerRef.current = setTimeout(() => {
                            setSearchText(value);
                          }, 1000);
                        }}
                        style={{ width: "100%" }}
                      />
                    </div>

                    <div className="tsep"></div>

                    <MultiSelect
                      value={selectedStatus}
                      onChange={(e) => setSelectedStatus(e.value)}
                      options={taskStatusType}
                      optionLabel="Name"
                      optionValue="Id"
                      placeholder="All Status"
                      filter
                      disabled={selectedStatus}
                    />

                    <MultiSelect
                      value={selectedAssingToName}
                      onChange={(e) => setSelectedAssingToName(e.value)}
                      options={employeDetails}
                      optionLabel="FullName"
                      optionValue="Id"
                      placeholder="Assigned To"
                      filter
                      itemTemplate={employeeOptionTemplate}
                      style={{ flex: "1 1 140px", minWidth: 130 }}
                    />

                    <MultiSelect
                      value={selectedType}
                      onChange={(e) => setSelectedType(e.value)}
                      options={taskType}
                      optionLabel="Name"
                      optionValue="Id"
                      placeholder="All Types"
                      filter
                    />

                    <MultiSelect
                      value={selectedPriority}
                      onChange={(e) => setSelectedPriority(e.value)}
                      options={taskPriorityType}
                      optionLabel="Name"
                      optionValue="Id"
                      placeholder="All Priority"
                      filter
                    />

                    <MultiSelect
                      value={selectedSeverity}
                      onChange={(e) => setSelectedSeverity(e.value)}
                      options={taskSeverityType}
                      optionLabel="Name"
                      optionValue="Id"
                      placeholder="All Severity"
                      filter
                    />

                    <Dropdown
                      value={selectedProject ?? null}
                      options={allProject}
                      optionLabel="Name"
                      optionValue="Id"
                      placeholder="All Projects"
                      disabled={selectedProject}
                      filter
                      showClear
                      style={{ flex: "1 1 193px", maxWidth: 193 }}
                      onChange={(e) => {
                        const val = e.value ?? null;
                        setSelectedProject(val);
                        selectedProjectRef.current = val;
                        setSelectedModule([]);
                        setSelectedSubModule([]);
                        setSelectedSegment([]);
                        setTaskModuleType([]);
                        setTaskSubModuleType([]);
                        setTaskSegmentType([]);
                        if (val) {
                          getMasterTaskModulesCategory(val);
                          getMasterTaskSegementCategory(val);
                        }
                      }}
                    />

                    <MultiSelect
                      value={selectedModule}
                      onChange={(e) => {
                        const val = e.value;
                        setSelectedModule(val);
                        setSelectedSubModule([]);
                        setTaskSubModuleType([]);
                        if (val?.length === 1)
                          getMasterTaskSubModuleCategory(
                            selectedProject,
                            val[0]
                          );
                      }}
                      options={taskModuleType}
                      optionLabel="Name"
                      optionValue="Id"
                      placeholder="Select Module"
                      filter
                      disabled={!selectedProject}
                    />

                    <MultiSelect
                      value={selectedSubModule}
                      onChange={(e) => setSelectedSubModule(e.value)}
                      options={taskSubModuleType}
                      optionLabel="Name"
                      optionValue="Id"
                      placeholder="Select Sub-Module"
                      filter
                      disabled={!selectedModule.length}
                    />

                    <MultiSelect
                      value={selectedSegment}
                      onChange={(e) => setSelectedSegment(e.value)}
                      options={taskSegmentType}
                      optionLabel="Name"
                      optionValue="Id"
                      placeholder="Select Segment"
                      filter
                      disabled={!selectedProject}
                    />
                    {/* 
                    <label
                      style={{
                        fontSize: "11px",
                        color: "var(--muted)",
                        whiteSpace: "nowrap",
                        marginBottom: "0",
                      }}
                    >
                      From:
                    </label>
                    <input
                      type="date"
                      className="fc"
                      style={{ width: "auto" }}
                      value={startDate}
                      disabled={!selectedProject}
                      onChange={(e) => setStartDate(e.target.value)}
                      onClick={(e) =>
                        e.target.showPicker && e.target.showPicker()
                      }
                    />
                    <span
                      style={{
                        fontSize: "11px",
                        color: "var(--muted)",
                        marginBottom: "0",
                      }}
                    >
                      To
                    </span>
                    <input
                      type="date"
                      className="fc"
                      style={{ width: "auto" }}
                      value={endDate}
                      disabled={!selectedProject}
                      onChange={(e) => setEndDate(e.target.value)}
                      onClick={(e) =>
                        e.target.showPicker && e.target.showPicker()
                      }
                    /> */}

                    <div className="tsep"></div>
                    <button
                      className="btn btn-ghost btn-sm"
                      onClick={clearFilters}
                      disabled={!hasActiveFilters}
                      title="Clear all filters"
                      style={{
                        opacity: hasActiveFilters ? 1 : 0.4,
                        cursor: hasActiveFilters ? "pointer" : "not-allowed",
                      }}
                    >
                      <i className="fa-solid fa-xmark"></i> Clear
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="flex" style={{ flex: "1" }}>
            <div
              style={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                overflowY: "hidden",
              }}
            >
              {/* LIST VIEW */}
              <div
                className="height-body-equal"
                id="listView"
                style={{ display: view === "list" ? "block" : "none" }}
              >
                <table className="dtbl">
                  <thead>
                    <tr>
                      <th>
                        <input
                          type="checkbox"
                          onChange={toggleAllSel}
                          checked={
                            backlogTasks.length > 0 &&
                            selectedTasks.length === backlogTasks.length
                          }
                        />
                      </th>
                      <th>Title</th>
                      <th>Task ID</th>
                      <th title="Type | Priority | Severity">TY | PR | SV</th>
                      <th>Status</th>
                      <th style={{ minWidth: "160px" }}>Assigned</th>
                      <th>Due By | Est(hr)</th>
                      <th className="task-actions-header">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredTasks?.filter((task) => task?.SprintId === 0)?.length === 0 ? (
                      <tr>
                        <td colSpan="13" style={{ textAlign: "center", padding: "20px" }}>
                          No Data Found
                        </td>
                      </tr>
                    ) : (
                      filteredTasks?.filter((task) => task?.SprintId === 0)?.map((task) => (
                        <tr
                          key={task?.Id}
                          onClick={() => {
                            openPanel(task.Id);
                            fetchPanelEmployees(task?.ProjectId || 0);
                          }}
                          className={`${selectedTask?.Id === task?.Id ? "row-selected" : ""}`}
                          style={{
                            background:
                              selectedTask?.Id === task?.Id
                                ? "var(--brand-soft, rgba(236,65,25,0.08))"
                                : "",
                            borderLeft:
                              selectedTask?.Id === task?.Id
                                ? "3px solid var(--brand)"
                                : "3px solid transparent",
                            transition: "background 0.15s, border-left 0.15s",
                          }}
                        >
                          <td onClick={(e) => e.stopPropagation()}>
                            <input
                              type="checkbox"
                              checked={selectedTasks.includes(task.Id)}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  setSelectedTasks(prev => [...prev, task.Id]);
                                  setShowBulkBar(true);
                                } else {
                                  const updated = selectedTasks.filter(id => id !== task.Id);
                                  setSelectedTasks(updated);
                                  if (updated.length === 0) setShowBulkBar(false);
                                }
                              }}
                            />
                          </td>
                          <td className="title-cell">
                            <p
                              className="mb-0 task-headingp"
                              style={{ fontWeight: 600 }}
                            >
                              <b>
                                {getValue(
                                  (() => {
                                    const max =
                                      selectedTask?.Id === task?.Id ? 45 : 65;
                                    return task.TaskTitle?.length > max
                                      ? task.TaskTitle.slice(0, max) + "..."
                                      : task.TaskTitle;
                                  })()
                                )}
                                <span
                                  title="Copy title with link"
                                  style={{ marginLeft: "6px", cursor: "pointer", flexShrink: 0, display: "inline-flex", verticalAlign: "middle" }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    const url = `https://app.orggenie.com/Project/Task/Detail/${task.GUID}`;
                                    const plainText = `${task.TaskTitle}\n${url}`;
                                    const htmlText = `<a href="${url}">${task.TaskTitle}</a>`;
                                    if (navigator.clipboard && window.ClipboardItem) {
                                      navigator.clipboard.write([new ClipboardItem({
                                        "text/plain": new Blob([plainText], { type: "text/plain" }),
                                        "text/html": new Blob([htmlText], { type: "text/html" }),
                                      })]);
                                    } else {
                                      navigator.clipboard.writeText(plainText);
                                    }
                                    setCopiedId(`tasknum-${task.Id}`);
                                    setTimeout(() => setCopiedId(null), 2000);
                                  }}
                                >
                                  {copiedId === `tasknum-${task.Id}` ? (
                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#22c55e" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" style={{ width: "13px", height: "13px" }}>
                                      <polyline points="20 6 9 17 4 12" />
                                    </svg>
                                  ) : (
                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#888" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ width: "13px", height: "13px" }}>
                                      <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
                                      <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
                                    </svg>

                                  )}
                                </span>

                              </b>

                              {task.ParentTaskId !== 0 && (
                                <svg
                                  // title={task?.ParentTaskNumber}
                                  xmlns="http://w3.org"
                                  viewBox="0 0 24 24"
                                  width="16"
                                  height="16"
                                  style={{ marginLeft: "6px", flexShrink: 0 }}
                                > <title>{task?.ParentTaskNumber}</title>
                                  <rect
                                    x="3"
                                    y="3"
                                    width="6"
                                    height="6"
                                    rx="1.5"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linejoin="round"
                                  />
                                  <line
                                    x1="12"
                                    y1="5"
                                    x2="21"
                                    y2="5"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                  />
                                  <line
                                    x1="12"
                                    y1="8"
                                    x2="18"
                                    y2="8"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                  />
                                  <path
                                    d="M6 10v6h4"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                  <rect
                                    x="12"
                                    y="13"
                                    width="6"
                                    height="6"
                                    rx="1"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linejoin="round"
                                  />
                                  <line
                                    x1="20"
                                    y1="15"
                                    x2="21"
                                    y2="15"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                  />
                                  <line
                                    x1="20"
                                    y1="18"
                                    x2="21"
                                    y2="18"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                  />
                                </svg>
                              )}
                            </p>
                            <p className="module-status">
                              <span>
                                <span
                                  title={task.IsPublic ? "Public" : "Private"}
                                  style={{
                                    fontSize: "11px",
                                    marginRight: "4px",
                                    marginLeft: "0",
                                    color: task.IsPublic
                                      ? "var(--red, #e53e3e)"
                                      : "var(--muted, #888)",
                                    flexShrink: 0,
                                  }}
                                >
                                  <i
                                    className={`fa-solid ${task.IsPublic ? "fa-lock-open" : "fa-lock"}`}
                                  ></i>
                                </span>
                                {getValue(task?.ProjectName)}
                              </span>
                              <span>| </span>
                              <span>{getValue(task.ModuleName)} - </span>
                              <span>{getValue(task.SubModuleName)}</span>
                              <span>| </span>
                              <span>{getValue(task.SegmentName)}</span>
                              <span>| </span>
                              <span
                                className="w-s"
                                style={{
                                  display: "flex",
                                  alignItems: "start",
                                  gap: "6px",
                                  whiteSpace: "nowrap",
                                }}
                                title="Created By"
                                onClick={() => {
                                  if (task?.CreatedByUserGUID) {
                                    window.open(
                                      `/Profile/${task?.CreatedByUserGUID}`,
                                      "_blank"
                                    );
                                  }
                                }}
                              >
                                <img
                                  src={
                                    task.CreatedByProfileImage ||
                                    "images/placeholder_profile.png"
                                  }
                                  onError={(e) =>
                                  (e.target.src =
                                    "/images/placeholder_profile.png")
                                  }
                                  style={{
                                    width: "15px",
                                    height: "15px",
                                    borderRadius: "50%",
                                  }}
                                />
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                  }}
                                >
                                  {getValue(task.CreatedByFullName)}
                                </div>
                              </span>
                            </p>
                          </td>
                          <td className="w-s">
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "4px",
                              }}
                            >
                              <b className="task-number-td">
                                {getValue(task.TaskNumber)}
                              </b>
                              <span
                                title="Copy Task ID"
                                style={{ cursor: "pointer", flexShrink: 0, lineHeight: 1 }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  navigator.clipboard.writeText(task.TaskNumber ?? "");
                                  setCopiedId(`title-${task.Id}`);
                                  setTimeout(() => setCopiedId(null), 1500);
                                }}
                              >
                                {copiedId === `title-${task.Id}` ? (
                                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#22c55e" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                                    <polyline points="20 6 9 17 4 12" />
                                  </svg>
                                ) : (
                                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#888" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
                                    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
                                  </svg>
                                )}
                              </span>
                            </div>
                          </td>
                          <td>
                            {getValue(task.TaskTypeName)}
                            <br />
                            {getValue(task.PriorityName)} |{" "}
                            {getValue(task.SeverityName)}
                          </td>
                          <td>
                            <div
                              className={`badge ${sBadge(task?.StatusName)}`}
                            >
                              {getValue(task.StatusName)}
                            </div>
                          </td>
                          <td>
                            <div
                              className="w-s"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                                width: "100px",
                                whiteSpace: "nowrap",
                              }}
                              title="Assigned By"
                              onClick={() => {
                                if (task?.AssignToUserGUID) {
                                  window.open(
                                    `/Profile/${task?.AssignToUserGUID}`,
                                    "_blank"
                                  );
                                }
                              }}
                            >
                              {task.AssignToProfileImage && (
                                <img
                                  src={
                                    task.AssignToProfileImage ||
                                    "images/placeholder_profile.png"
                                  }
                                  onError={(e) =>
                                  (e.target.src =
                                    "/images/placeholder_profile.png")
                                  }
                                  style={{
                                    width: "20px",
                                    height: "20px",
                                    borderRadius: "50%",
                                  }}
                                />
                              )}
                              {getValue(task.AssignToName)}
                            </div>
                          </td>
                          <td>
                            {task.DueDate
                              ? new Date(task.DueDate).toLocaleDateString()
                              : "N/A"}
                            <br />
                            {task.EstimatedHours
                              ? `${task.EstimatedHours}h`
                              : "N/A"}
                          </td>
                          <td
                            className="task-actions-cell"
                            onClick={(e) => e.stopPropagation()}
                          >
                            <div className="flex gap4 task-actions">
                              <button
                                title="Clone"
                                type="button"
                                onClick={() => {
                                  setAddModalOpen(true);
                                  setEditTaskDetails(task);
                                  setParentId(0);
                                  setProjectId(task?.ProjectId);
                                  setTaskCopy(true);
                                }}
                                className="btn btn-ghost btn-icon"
                              >
                                <i className="fa-solid fa-copy"></i>
                              </button>
                              <button
                                title="Edit"
                                type="button"
                                onClick={() => {
                                  setAddModalOpen(true);
                                  setEditTaskDetails(task);
                                  setParentId(0);
                                  setProjectId(task?.ProjectId);
                                  setTaskCopy(false);
                                }}
                                className="btn btn-ghost btn-icon"
                              >
                                <i className="fa-solid fa-pen"></i>
                              </button>
                              <button
                                title="Delete"
                                className="btn btn-ghost btn-icon"
                                style={{ color: "var(--red)" }}
                                onClick={() => {
                                  setDeleteModal(true);
                                  setDeletedTaskId(task?.Id);
                                }}
                              >
                                <i className="fa-solid fa-trash"></i>
                              </button>
                              {(createProject || userDetails?.EmpId == contextProject?.ManagerId) && (
                                <div className="bt-move-wrap" style={{ position: "relative" }}>
                                  <button
                                    className="bt-move-btn"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      if (sprintDropdownTaskId === task.Id) {
                                        setSprintDropdownTaskId(null); // toggle close
                                      } else {
                                        setSelectedProjectData(contextProject);
                                        setSprintDropdownTaskId(task.Id);
                                      }
                                    }}
                                    title="Move to Sprint"
                                  >
                                    {/* <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-send" viewBox="0 0 16 16">
                                    <path d="M15.854.146a.5.5 0 0 1 .11.54l-5.819 14.547a.75.75 0 0 1-1.329.124l-3.178-4.995L.643 7.184a.75.75 0 0 1 .124-1.33L15.314.037a.5.5 0 0 1 .54.11ZM6.636 10.07l2.761 4.338L14.13 2.576zm6.787-8.201L1.591 6.602l4.339 2.76z" />
                                  </svg> */}
                                    <i className="fa-solid fa-arrow-right-to-bracket" style={{ fontSize: "11px" }}></i>
                                    <i className="fa-solid fa-chevron-down" style={{ fontSize: "8px" }}></i>
                                  </button>

                                  {sprintDropdownTaskId === task.Id && (
                                    <div className="sprint-pick-dd open"

                                      onClick={(e) => e.stopPropagation()}
                                    >
                                      <div style={{ padding: "6px 12px", fontSize: "11px", color: "var(--muted)", fontWeight: 600, borderBottom: "1px solid var(--border)" }}>
                                        Move to Sprint
                                      </div>

                                      {/* Active Sprint */}
                                      {selectedProjectData?.ProjectSprints?.ActiveSprint && (
                                        <div
                                          style={{ padding: "8px 14px", cursor: "pointer", fontSize: "13px", display: "flex", alignItems: "center", gap: "8px" }}
                                          className="sprint-drop-item"
                                          onMouseEnter={e => e.currentTarget.style.background = "var(--brand-soft, #fef2f0)"}
                                          onMouseLeave={e => e.currentTarget.style.background = "transparent"}
                                          onClick={() => {
                                            setIsSprintModal(true);
                                            setMoveSprint({ ...task, targetSprint: selectedProjectData.ProjectSprints.ActiveSprint });
                                            setSprintDropdownTaskId(null);
                                          }}
                                        >
                                          <span style={{ width: "8px", height: "8px", borderRadius: "50%", background: "#22c55e", flexShrink: 0, display: "inline-block" }}></span>
                                          <span>
                                            <span style={{ fontSize: "10px", color: "var(--muted)", display: "block" }}>Active Sprint</span>
                                            {selectedProjectData.ProjectSprints.ActiveSprint.SprintName}
                                          </span>
                                        </div>
                                      )}

                                      {/* Planning Sprints */}
                                      {selectedProjectData?.ProjectSprints?.PlanningSprint?.length > 0 &&
                                        selectedProjectData.ProjectSprints.PlanningSprint.map((sprint) => (
                                          <div
                                            key={sprint.Id}
                                            style={{ padding: "8px 14px", cursor: "pointer", fontSize: "13px", display: "flex", alignItems: "center", gap: "8px" }}
                                            onMouseEnter={e => e.currentTarget.style.background = "var(--brand-soft, #fef2f0)"}
                                            onMouseLeave={e => e.currentTarget.style.background = "transparent"}
                                            onClick={() => {
                                              setIsSprintModal(true);
                                              setMoveSprint({ ...task, targetSprint: sprint });
                                              setSprintDropdownTaskId(null);
                                            }}
                                          >
                                            <span style={{ width: "8px", height: "8px", borderRadius: "50%", background: "#3b82f6", flexShrink: 0, display: "inline-block" }}></span>
                                            <span>
                                              <span style={{ fontSize: "10px", color: "var(--muted)", display: "block" }}>Planning Sprint</span>
                                              {sprint.SprintName}
                                            </span>
                                          </div>
                                        ))
                                      }

                                      {/* Agar koi sprint nahi */}
                                      {!selectedProjectData?.ProjectSprints?.ActiveSprint &&
                                        !selectedProjectData?.ProjectSprints?.PlanningSprint?.length && (
                                          <div style={{ padding: "10px 14px", fontSize: "13px", color: "var(--muted)" }}>
                                            No sprints available
                                          </div>
                                        )}
                                    </div>
                                  )}
                                </div>)}
                            </div>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
                <Paginator
                  first={first}
                  rows={rows}
                  totalRecords={totalRecords}
                  rowsPerPageOptions={[50, 100, 200, 500]}
                  onPageChange={onPageChange}
                />
              </div>

            </div>

            {/* SIDE PANEL */}
            <div
              className={`sp${selectedTask ? " open" : ""}`}
              id="sidePanel"
            >
              {selectedTask ? (
                <>
                  <div className="sp-hd">
                    <h5>{selectedTask.TaskNumber}</h5>
                    <button
                      className="btn btn-ghost btn-icon"
                      onClick={() => {
                        setAddModalOpen(true);
                        setEditTaskDetails(selectedTask);
                        setParentId(0);
                        setProjectId(selectedTask?.ProjectId);
                        setTaskCopy(false);
                      }}
                      title="Edit"
                    >
                      <i className="fa-solid fa-pen"></i>
                    </button>
                    <button
                      type="button"
                      onClick={() => taskDetail(selectedTask?.GUID)}
                      className="btn btn-ghost btn-icon"
                      title="Full View"
                    >
                      <i className="fa-solid fa-arrow-up-right-from-square"></i>
                    </button>
                    <button
                      type="button"
                      onClick={closePanel}
                      className="btn btn-ghost btn-icon"
                      title="Close"
                    >
                      <i className="fa-solid fa-xmark"></i>
                    </button>
                  </div>

                  <div className="sp-bd">
                    <div
                      className="flex project-badge-area"
                      style={{ gap: 5 }}
                    >
                      <span className="badge bg-critical">
                        {selectedTask.PriorityName || "N/A"}
                      </span>
                      <span className="badge bg-blocker">
                        {selectedTask.SeverityName || "N/A"}
                      </span>
                      <span className="badge bg-bug">
                        {selectedTask.TaskTypeName || "N/A"}
                      </span>
                      <div className="bt-move-wrap" style={{ position: "relative" }}>
                        <button
                          className="bt-move-btn"
                          disabled={!(createProject || userDetails?.EmpId == contextProject?.ManagerId)}
                          onClick={(e) => {
                            e.stopPropagation();
                            if (sprintDropdownTaskId === selectedTask.Id) {
                              setSprintDropdownTaskId(null); // toggle close
                            } else {
                              setSelectedProjectData(contextProject);
                              setSprintDropdownTaskId(selectedTask.Id);
                            }
                          }}
                          title="Move to Sprint"
                        >
                          {/* <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-send" viewBox="0 0 16 16">
                                    <path d="M15.854.146a.5.5 0 0 1 .11.54l-5.819 14.547a.75.75 0 0 1-1.329.124l-3.178-4.995L.643 7.184a.75.75 0 0 1 .124-1.33L15.314.037a.5.5 0 0 1 .54.11ZM6.636 10.07l2.761 4.338L14.13 2.576zm6.787-8.201L1.591 6.602l4.339 2.76z" />
                                  </svg> */}
                          <i className="fa-solid fa-arrow-right-to-bracket" style={{ fontSize: "11px" }}></i> {selectedTask?.SprintName ? selectedTask.SprintName : "Backlog"}
                          <i className="fa-solid fa-chevron-down" style={{ fontSize: "8px" }}></i>
                        </button>

                        {sprintDropdownTaskId === selectedTask.Id && (
                          <div className="sprint-pick-dd open"

                            onClick={(e) => e.stopPropagation()}
                          >
                            <div style={{ padding: "6px 12px", fontSize: "11px", color: "var(--muted)", fontWeight: 600, borderBottom: "1px solid var(--border)" }}>
                              Move to Sprint
                            </div>

                            {/* Active Sprint */}
                            {selectedProjectData?.ProjectSprints?.ActiveSprint && (
                              <div
                                style={{ padding: "8px 14px", cursor: "pointer", fontSize: "13px", display: "flex", alignItems: "center", gap: "8px" }}
                                className="sprint-drop-item"
                                onMouseEnter={e => e.currentTarget.style.background = "var(--brand-soft, #fef2f0)"}
                                onMouseLeave={e => e.currentTarget.style.background = "transparent"}
                                onClick={() => {
                                  setIsSprintModal(true);
                                  setMoveSprint({ ...selectedTask, targetSprint: selectedProjectData.ProjectSprints.ActiveSprint });
                                  setSprintDropdownTaskId(null);
                                }}
                              >
                                <span style={{ width: "8px", height: "8px", borderRadius: "50%", background: "#22c55e", flexShrink: 0, display: "inline-block" }}></span>
                                <span>
                                  <span style={{ fontSize: "10px", color: "var(--muted)", display: "block" }}>Active Sprint</span>
                                  {selectedProjectData.ProjectSprints.ActiveSprint.SprintName}
                                </span>
                              </div>
                            )}

                            {/* Planning Sprints */}
                            {selectedProjectData?.ProjectSprints?.PlanningSprint?.length > 0 &&
                              selectedProjectData.ProjectSprints.PlanningSprint.map((sprint) => (
                                <div
                                  key={sprint.Id}
                                  style={{ padding: "8px 14px", cursor: "pointer", fontSize: "13px", display: "flex", alignItems: "center", gap: "8px" }}
                                  onMouseEnter={e => e.currentTarget.style.background = "var(--brand-soft, #fef2f0)"}
                                  onMouseLeave={e => e.currentTarget.style.background = "transparent"}
                                  onClick={() => {
                                    setIsSprintModal(true);
                                    setMoveSprint({ ...selectedTask, targetSprint: sprint });
                                    setSprintDropdownTaskId(null);
                                  }}
                                >
                                  <span style={{ width: "8px", height: "8px", borderRadius: "50%", background: "#3b82f6", flexShrink: 0, display: "inline-block" }}></span>
                                  <span>
                                    <span style={{ fontSize: "10px", color: "var(--muted)", display: "block" }}>Planning Sprint</span>
                                    {sprint.SprintName}
                                  </span>
                                </div>
                              ))
                            }

                            {/* Agar koi sprint nahi */}
                            {!selectedProjectData?.ProjectSprints?.ActiveSprint &&
                              !selectedProjectData?.ProjectSprints?.PlanningSprint?.length && (
                                <div style={{ padding: "10px 14px", fontSize: "13px", color: "var(--muted)" }}>
                                  No sprints available
                                </div>
                              )}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="project-task-title">
                      {selectedTask.TaskTitle || "No Title"}
                    </div>

                    <div className="ql-editor project-task-description">
                      <div
                        dangerouslySetInnerHTML={{
                          __html:
                            selectedTask.TaskDescription ||
                            "<p>No description</p>",
                        }}
                      />
                    </div>

                    <div className="task-project-bx">
                      <div className="task-project-inner">
                        <div className="task-project-heading">
                          <strong>Project:</strong>
                        </div>
                        <div className="task-project-value">
                          {selectedTask.ProjectName || "N/A"}
                        </div>
                      </div>
                      <div className="task-project-inner">
                        <div className="task-project-heading">
                          <strong>Segment:</strong>
                        </div>
                        <div className="task-project-value">
                          {selectedTask.SegmentName || "N/A"}
                        </div>
                      </div>
                      <div className="task-project-inner">
                        <div className="task-project-heading">
                          <strong>Status:</strong>
                        </div>
                        <div className="task-project-value">
                          <select
                            className="sp-inline-select"
                            value={selectedTask.StatusName || ""}
                            onChange={(e) =>
                              handleStatusChange(
                                selectedTask.Id,
                                e.target.value
                              )
                            }
                          >
                            {["Open", "In Progress", "Review", "Done", "Closed"]
                              .filter(
                                (status) =>
                                  status !== "Closed" ||
                                  userPermissions?.some(
                                    (p) =>
                                      p?.PermissionName === "Task.Close"
                                  )
                              )
                              .map((status) => (
                                <option key={status} value={status}>
                                  {status}
                                </option>
                              ))}
                          </select>
                        </div>
                      </div>
                      <div className="task-project-inner">
                        <div className="task-project-heading">
                          <strong>Assigned To:</strong>
                        </div>
                        <div className="task-project-value">
                          <select
                            className="sp-inline-select"
                            value={selectedTask.AssignedToId || ""}
                            onChange={(e) =>
                              handleAssigneeChange(Number(e.target.value))
                            }
                          >
                            {!panelEmployees?.some(
                              (emp) =>
                                emp.Id === selectedTask.AssignedToId
                            ) && (
                                <option
                                  value={selectedTask.AssignedToId || ""}
                                >
                                  {selectedTask.AssignToName ||
                                    "Select Employee"}
                                </option>
                              )}
                            {panelEmployees?.map((emp) => (
                              <option key={emp.Id} value={emp.Id}>
                                {emp.FullName}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div className="task-project-inner">
                        <div className="task-project-heading">
                          <strong>Module:</strong>
                        </div>
                        <div className="task-project-value">
                          {selectedTask.ModuleName || "N/A"}
                        </div>
                      </div>
                      <div className="task-project-inner">
                        <div className="task-project-heading">
                          <strong>Sub Module:</strong>
                        </div>
                        <div className="task-project-value">
                          {selectedTask.SubModuleName || "N/A"}
                        </div>
                      </div>
                      <div className="task-project-inner">
                        <div className="task-project-heading">
                          <strong>Reporter:</strong>
                        </div>
                        <div className="task-project-value">
                          {selectedTask.ReporterFullName ||
                            selectedTask.RaisedByName ||
                            "N/A"}
                        </div>
                      </div>
                      <div className="task-project-inner">
                        <div className="task-project-heading">
                          <strong>Est Time:</strong>
                        </div>
                        <div className="task-project-value">
                          {selectedTask.EstimatedHours
                            ? `${selectedTask.EstimatedHours}h`
                            : "N/A"}
                        </div>
                      </div>
                      <div className="task-project-inner">
                        <div className="task-project-heading">
                          <strong>Actual Time:</strong>
                        </div>
                        <div className="task-project-value">
                          {selectedTask.ActualHours
                            ? `${selectedTask.ActualHours}h`
                            : "N/A"}
                        </div>
                      </div>
                      <div className="task-project-inner">
                        <div className="task-project-heading">
                          <strong>Due By:</strong>
                        </div>
                        <div className="task-project-value">
                          {selectedTask.DueDate
                            ? new Date(
                              selectedTask.DueDate
                            ).toLocaleDateString()
                            : "N/A"}
                        </div>
                      </div>
                    </div>
                    <div className="project-task-status">
                      <div className="staus-project-title">Change Status</div>
                      <div className="status-wrap-project">
                        {["Open", "In Progress", "Review", "Done", "Closed"]
                          .filter(
                            (status) =>
                              status !== "Closed" ||
                              userPermissions?.some(
                                (userPermission) =>
                                  userPermission?.PermissionName ===
                                  "Task.Close"
                              )
                          )
                          .map((status) => (
                            <button
                              key={status}
                              type="button"
                              className={`btn btn-sm ${selectedTask.StatusName === status
                                ? "btn-brand"
                                : "btn-outline"
                                }`}
                              onClick={() =>
                                handleStatusChange(selectedTask.Id, status)
                              }
                            >
                              {status}
                            </button>
                          ))}
                      </div>
                    </div>
                  </div>
                </>
              ) : null}
            </div>
          </div>
        </div>
      </div>

      {/* ADD/EDIT TASK MODAL */}
      {isModalOpen && (
        <AddTask
          isOpen={isModalOpen}
          onClose={(e) => onClosePopup(e)}
          editTaskDetails={editTaskDetails}
          subTaskProjectId={subTaskProjectId}
          parentId={parentId}
          taskCopy={taskCopy}
          detailPage={false}
        />
      )}

      {/* Delete Confirmation */}
      {isDeletedModal && (
        <div
          className="modal show"
          id="delete-task-confirm"
          style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content delete-holiday">
              <div className="modal-header">
                <img
                  src="/images/org-img/leave/popup-backimg.png"
                  className="backimg"
                />
                <div className="img">
                  <img src="/images/org-img/leave/trash.png" />
                </div>
              </div>
              <div className="modal-body text-center">
                <p>Are you sure you want to delete this task?</p>
              </div>
              <div className="modal-footer m-auto">
                <button
                  type="button"
                  className="cancelbtn-click"
                  onClick={() => {
                    setDeleteModal(false);
                    setDeletedTaskId(0);
                  }}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="deletebtn-click"
                  onClick={() => taskDelete()}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Email Confirmation */}
      {isSprintModal && (
        <div
          className="modal show"
          id="delete-task-confirm"
          style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content delete-holiday">
              <div className="modal-header">
                <img
                  src="/images/org-img/leave/popup-backimg.png"
                  className="backimg"
                />
                <div className="img">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-send" viewBox="0 0 16 16">
                    <path d="M15.854.146a.5.5 0 0 1 .11.54l-5.819 14.547a.75.75 0 0 1-1.329.124l-3.178-4.995L.643 7.184a.75.75 0 0 1 .124-1.33L15.314.037a.5.5 0 0 1 .54.11ZM6.636 10.07l2.761 4.338L14.13 2.576zm6.787-8.201L1.591 6.602l4.339 2.76z" />
                  </svg>
                </div>
              </div>
              <div className="modal-body text-center">
                <p>Are you sure you want to move to this sprint?</p>
              </div>
              <div className="modal-footer m-auto">
                <button
                  type="button"
                  className="cancelbtn-click"
                  onClick={() => {
                    setIsSprintModal(false);

                  }}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="deletebtn-click"
                  onClick={() => {

                    sendMoveSprint();
                    // Proceed with sending email
                  }}
                >
                  Move To Sprint
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showBulkBar && selectedTasks.length > 0 && (
        <div
          id="bulkBar"
          style={{
            position: "fixed",
            bottom: "24px",
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            gap: "10px",
            padding: "10px 18px",
            background: "var(--card)",
            border: "1px solid var(--border)",
            borderRadius: "var(--radius)",
            boxShadow: "0 4px 20px rgba(0,0,0,0.12)",
            minWidth: "320px",
          }}
        >
          <span style={{ fontSize: "13px", fontWeight: 700, color: "var(--brand)", whiteSpace: "nowrap" }}>
            {selectedTasks.length} task{selectedTasks.length > 1 ? "s" : ""} selected
          </span>
          <div className="tsep" />
          {(() => {
            const selectedTaskObjs = filteredTasks.filter(t => selectedTasks.includes(t.Id) && t.SprintId === 0);
            const uniqueProjectIds = [...new Set(selectedTaskObjs.map(t => t.ProjectId))];
            const sprintMap = new Map();
            uniqueProjectIds.forEach(pid => {
              // const proj = allProject.find(p => p.Id === pid);
              if (contextProject?.ProjectSprints?.ActiveSprint) {
                const s = contextProject.ProjectSprints.ActiveSprint;
                if (!sprintMap.has(s.Id)) sprintMap.set(s.Id, { ...s, _type: "Active" });
              }
              (contextProject?.ProjectSprints?.PlanningSprint || []).forEach(s => {
                if (!sprintMap.has(s.Id)) sprintMap.set(s.Id, { ...s, _type: "Planning" });
              });
            });
            const sprints = [...sprintMap.values()];

            return sprints.length > 0 ? (
              <div className="bt-move-wrap" style={{ position: "relative" }}>
                <button
                  className="btn btn-outline btn-sm"
                  disabled={!(createProject || userDetails?.EmpId == contextProject?.ManagerId)}
                  style={{ display: "flex", alignItems: "center", gap: "6px", whiteSpace: "nowrap" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    setSprintDropdownTaskId(sprintDropdownTaskId === "bulk" ? null : "bulk");
                  }}
                >
                  <i className="fa-solid fa-arrow-right-to-bracket" style={{ fontSize: "11px" }} />
                  Move to Sprint
                  <i className="fa-solid fa-chevron-down" style={{ fontSize: "8px" }} />
                </button>

                {sprintDropdownTaskId === "bulk" && (
                  <div
                    className="sprint-pick-dd open"
                    style={{ bottom: "calc(100% + 6px)", top: "auto", minWidth: "200px" }}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <div style={{ padding: "6px 12px", fontSize: "11px", color: "var(--muted)", fontWeight: 600, borderBottom: "1px solid var(--border)" }}>
                      Move {selectedTasks.length} task(s) to Sprint
                    </div>
                    {sprints.map(sprint => (
                      <div
                        key={sprint.Id}
                        className="sprint-drop-item"
                        style={{ padding: "8px 14px", cursor: "pointer", fontSize: "13px", display: "flex", alignItems: "center", gap: "8px" }}
                        onMouseEnter={e => e.currentTarget.style.background = "var(--brand-soft, #fef2f0)"}
                        onMouseLeave={e => e.currentTarget.style.background = "transparent"}
                        onClick={() => {
                          setSprintDropdownTaskId(null);
                          sendBulkMoveSprint(sprint);
                        }}
                      >
                        <span style={{
                          width: "8px", height: "8px", borderRadius: "50%",
                          background: sprint._type === "Active" ? "#22c55e" : "#3b82f6",
                          flexShrink: 0, display: "inline-block"
                        }} />
                        <span>
                          <span style={{ fontSize: "10px", color: "var(--muted)", display: "block" }}>
                            {sprint._type} Sprint
                          </span>
                          {sprint.SprintName}
                        </span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ) : (
              <span style={{ fontSize: "12px", color: "var(--muted)" }}>No sprints available</span>
            );
          })()}

          <div className="tsep" />

          <button
            className="btn btn-ghost btn-sm"
            onClick={() => {
              setShowBulkBar(false);
              setSelectedTasks([]);
              setSprintDropdownTaskId(null);
            }}
          >
            <i className="fa-solid fa-xmark" /> Cancel
          </button>
        </div>
      )}

      {(Isloading || IsApiloading) && (
        <Suspense>
          <ComponentLoader />
        </Suspense>
      )}
    </div>
  );
};

export default BackLockSprints;